import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TextInput, FileInput, NumberInput, DateInput, SelectInput } from 'components/input';
import { ImageField } from 'components/field';
import { SimpleForm } from 'components/form';
import { Create } from 'components/detail';

import * as urls from './urls';

import { maxLength } from "components/form/validate";

import {
  InputOptions,
} from 'util/constants'
import * as utils from "./utils";

class BannerCreateBase extends Component {

  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('description', record['description']);
    formDataRecord.append('redirect_url', record['redirect_url']);
    formDataRecord.append('priority', record['priority']);
    formDataRecord.append('valid_from', record['valid_from']);
    formDataRecord.append('valid_to', record['valid_to']);
    formDataRecord.append('status', record['status']);
    formDataRecord.append('image', record['image']);

    props.crudCreate(props.resource, formDataRecord, props.createBackendPath, basePath);
  };

  render() {
    return (
      <Create
        createBackendPath={urls.bannerCreateBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput
            source='description'
            label='Description'
            isRequired={true}
            validators={[maxLength(100)]}
            options={InputOptions}
          />
          <TextInput
            source='redirect_url'
            label='Redirect URL'
            isRequired={true}
            options={InputOptions}
          />
          <NumberInput
            source='priority'
            label='Priority'
            isRequired={true}
            options={InputOptions}
          />
          <DateInput
            source='valid_from'
            label='Valid From'
            isRequired={true}
            options={InputOptions}
          />
          <DateInput
            source='valid_to'
            label='Valid To'
            isRequired={true}
            options={InputOptions}
          />
          <SelectInput
            source='status'
            label='Status'
            choices={utils.BANNER_STATUS_CHOICES}
            isRequired={true}
            options={InputOptions}
          />
          <FileInput
            source='image'
            label='Image'
            placeholder={<p>Select or drop your file here</p>}
          >
            <ImageField source="src" title="title"/>
          </FileInput>
        </SimpleForm>
      </Create>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.admin.loading > 0,
  }
};

export const BannerCreate =  connect(
  mapStateToProps,
  {}
)(BannerCreateBase);


// WEBPACK FOOTER //
// ./src/routes/news/BannerCreate.js